import { combineReducers } from 'redux-immutable'
import { handleActions, combineActions } from 'redux-actions'
import { BidirectionalPagedData, combinePagedData } from 'utils/paging'
import * as actions from './actions'

const status = handleActions({
  [combineActions(
    actions.fetchTimelineEventsForEndUserPending,
    actions.fetchTimelineEventsForEndUserCancelled,
    actions.fetchTimelineEventsForEndUserFailed,
    actions.fetchTimelineEventsForEndUserSuccess,
    actions.loadMoreTimelineEventsForEndUserPending,
    actions.loadMoreTimelineEventsForEndUserCancelled,
    actions.loadMoreTimelineEventsForEndUserFailed,
    actions.loadMoreTimelineEventsForEndUserSuccess,
  )]: (state, action) => {
    return action.type
  },
}, null)

const events = handleActions({
  [actions.fetchTimelineEventsForEndUser]: () => {
    return BidirectionalPagedData()
  },

  [actions.fetchTimelineEventsForEndUserSuccess]: (state, action) => {
    return action.payload
  },

  [actions.loadMoreTimelineEventsForEndUserSuccess]: (state, action) => {
    return combinePagedData(state, action.payload)
  },
}, BidirectionalPagedData())

export default combineReducers({ status, events })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/endUser/timeline/reducer.js